export default "__VITE_ASSET__B3qv_na7__"